import FeeWaiverSelect from "@/components/form/fee-waiver-select";
import {
  makePickerField,
  type PickerFieldProps,
} from "@/fields/_internal/make-picker-field";

/** **Value is a boolean** — whether the diagnostics fee is waived. */
export type FeeWaiverFieldProps = PickerFieldProps<boolean>;

export const FeeWaiverField = makePickerField<boolean>({
  name: "FeeWaiverField",
  control: FeeWaiverSelect,
  popout: true,
});
